import * as angular from "angular";

export class PrivacyNoticeService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = "/v2/privacynotice";
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot, data);
    }

    acknowledge(data: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/acknowledge/" + data.pnid,
            data
        );
    }

    all(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/all", data);
    }

    pending(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/pending", data);
    }
}

angular
    .module("vcServices")
    .service("PrivacyNoticeService", PrivacyNoticeService);
